import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import { LoadableLazy } from '@confluence/loadable';

const createLoadingComponent = () => {
	return UFOLoadHold({
		name: 'LoadingConfluenceRightPanelBundle',
	});
};
export const PanelLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RightPanel" */ './RightPanel')).RightPanel,
	loading: createLoadingComponent,
});
